import {
    getCurrentCameraDistance,
    getOrbitControlsDistanceAndPan,
    getPolarAngleFromViewMode,
    getWorldData,
    setMinAndMaxControlsDistance,
    setOrbitControls, setPanLimits,
    setPolarAngle,
    setSmoothDistance,
} from '../controls/orbitControls';
import { ViewMode } from '../../common';
import {Buildings, isMobile, projectMode, settingsData, threeJsVariables} from '../../settings';
import { moveElements } from '../navigation/right-nav-bar';
import {
    cylinderFloorNumbers,
    removeCylinderFloorNumbers, rotateCylinderFloorNumbers,
} from '../cylinderFloorNumbers/cylinderFloorNumbers';
import { FloorSlider } from '../floorSlider/floorSlider';
import { enableSwitcherBtns, rotation_to_flat, setColorsKeyPlan, userPrevent } from '../../functions';
import {
    floorMoveAnimation
} from '../controls/destroyBuilding';
import { UnitCardClass } from '../cards/unitCards/UnitCardClass';
import { disableArrowButtons, moveCardWhenBuildingDestroyed } from '../cards/unitCards/unitCardFunctions';
import { compassPositionChange } from '../compass/compass';
import { Vector3 } from 'three';
import { animateCamera } from '../threejs/animation';
import TWEEN from '../../libs/tween.umd';
import { flatLabels, flatLabelsRemove } from '../flatLabels/flatLabels';
import { canvasResize } from '../../app';
import { Amenities } from '../amenities/Amenities';

export class FloorPlan {
    constructor () {
        this.minAngle = getPolarAngleFromViewMode(ViewMode.FloorPlan).minAngle;
        this.minDistance = null;
        this.maxDistance = null;
        // this.activeBuilding = null;
        this.buildingSwitcher = null;
        this.floorSlider = null;
    }

    async enter(){
        if (userPrevent()) return;
        userPrevent(true);
        settingsData.activeModeSwitching = true;
        this.buildingSwitcher = document.getElementById('building-switcher');
        this.buildingSwitcher && this.buildingSwitcher.classList.add('hide');

        enableSwitcherBtns(true);

        this.updateVariables();

        const activeBuilding = Buildings.getActiveBuilding();
        // const active = threeJsVariables.scene.getObjectByName(activeBuilding.name);
        // const roof = active.children.find(el => el.name.startsWith('Roof'));
        if (!projectMode.LiteMode.isActive() || projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('regular')) {
            const roof = activeBuilding.amenities['Roof'].mesh;
            roof.position.y = roof.position.y + 400;
        }

        settingsData.buildingDestroyed = true;

        Amenities.hide();

        disableArrowButtons();

        removeCylinderFloorNumbers();
        threeJsVariables.perspectiveCamera.userData.startAnimationDistance = getCurrentCameraDistance();

        const {floorVector,flatVector} = getWorldData(settingsData.lastClickedFlat);
        const destroyTarget = new Vector3(flatVector.x,floorVector.y,flatVector.z);

        setColorsKeyPlan(settingsData.currentFloor);
        await this.destroyBuilding(settingsData.currentFloor,destroyTarget);

        setOrbitControls(ViewMode.FloorPlan);
        setPolarAngle(ViewMode.FloorPlan);
        setMinAndMaxControlsDistance(ViewMode.FloorPlan);

        // floorSlider();
        this.floorSlider = new FloorSlider(document.querySelector('.buttons__wrapper'));
        this.floorSlider.create();


        moveElements();
        moveCardWhenBuildingDestroyed(UnitCardClass.findCard()?.html);
        compassPositionChange();

        settingsData.activeViewMode = 'floorplan';
        settingsData.activeModeSwitching = false;
        userPrevent(false);
    }

    async up(floor, apartment){
        userPrevent(true);
        flatLabelsRemove();

        const activeBuilding = Buildings.getActiveBuilding();
        const flat = activeBuilding.getFloorSelections(floor,false)[0];
        settingsData.aptFloorNum = flat.userData.crm_data.floorNum;
        floorMoveAnimation(settingsData.currentFloor, 'appear', floor)
            .then(()=> {
                flatLabels(floor);
                isMobile && canvasResize();
                // this.floorSlider.unblock();
                this.floorSlider.updateScroll(floor);
            });
        settingsData.currentFloor = floor;

        setColorsKeyPlan(floor);
        const {cameraVector} = getWorldData(flat);

        let target;

        target = new Vector3().copy(cameraVector).setY(flat.userData.baseWorldPosition.y);

        await this.destroyCameraAnimation(target, `appear`,flat);

        if (apartment && apartment.isMesh){
           rotation_to_flat(apartment);
        }
        userPrevent(false);
    }

    async down(floor,apartment){
        userPrevent(true);
        flatLabelsRemove();

        // const flat = this.activeBuilding.floor_obj[floor].filter(apt => apt.userData.crm_data)[0];
        const activeBuilding = Buildings.getActiveBuilding();
        const flat = activeBuilding.getFloorSelections(floor,false)[0];
        let targetPosition;
        settingsData.currentFloor = floor;
        settingsData.aptFloorNum = flat.userData.crm_data.floorNum;
        flat.updateWorldMatrix(true, false);
        const {cameraVector,floorVector,orbitControlsVector} = getWorldData(flat);

        targetPosition = new Vector3().copy(cameraVector).setY(flat.userData.baseWorldPosition.y);

        // if (targetApt && targetApt.isMesh){
        //     this.aptPositionVector = targetApt.getWorldPosition(new Vector3());
        //     this.aptTargetVector = new Vector3().copy(orbitControlsVector).setY(this.aptPositionVector.y);
        //     this.directionVector.subVectors(this.aptPositionVector,orbitControlsVector).normalize().add(this.aptTargetVector);
        //     targetPosition = this.directionVector;
        // }

        setColorsKeyPlan(floor);
        await this.destroyBuilding(floor, targetPosition);
        this.floorSlider.updateScroll(settingsData.currentFloor);

        if (apartment && apartment.isMesh){
            rotation_to_flat(apartment);
        }
        userPrevent(false);
    }

    async destroyBuilding(currentFloor_var, targetPosition){
        enableSwitcherBtns(false);
        settingsData.tween_animations = [];

        floorMoveAnimation(currentFloor_var, 'destroy')
            .then(()=> {
                flatLabels(settingsData.currentFloor);
                isMobile && canvasResize();
            });

        await this.destroyCameraAnimation(targetPosition);
    }

    async destroyCameraAnimation(targetPosition, upper, flat){
        const apt = flat ? flat : settingsData.lastClickedFlat;
        const {cameraVector, orbitControlsVector, flatVector} = getWorldData(apt);
        const distanceCorrection = config.threejs.animations.destroyCameraAnimation.distanceCorrection;

        const position = targetPosition ? targetPosition : flatVector;

        const aptTarget = new Vector3().copy(orbitControlsVector).setY(position.y);
        const aptPosition = new Vector3().subVectors(position,aptTarget).normalize().setY(position.y).setLength(this.minDistance * distanceCorrection).add(aptTarget);

        await animateCamera(
            cameraVector,
            aptPosition,
            orbitControlsVector,
            aptTarget,
            undefined,
            this.minDistance,
            this.minAngle,
            0,
            1000,
            TWEEN.Easing.Linear.None,
            () => {
            },
            () => {
                threeJsVariables.orbitControls.saveState();
            }
        );
    }

    async appearCameraAnimation(){
        const {minDistance} = getOrbitControlsDistanceAndPan(ViewMode.Cylinder);
        const {cameraVector, orbitControlsVector} = getWorldData();
        const {minAngle} = getPolarAngleFromViewMode(ViewMode.Cylinder);
        const cameraStartAnimationDistance = threeJsVariables.perspectiveCamera.userData.startAnimationDistance;
        const orbitSaveState = threeJsVariables.orbitControls.target0;
        const position = new Vector3().subVectors(cameraVector,orbitControlsVector).normalize().setLength(cameraStartAnimationDistance).add(orbitSaveState);

        await animateCamera(
            cameraVector,
            position,
            orbitControlsVector,
            orbitSaveState,
            undefined,
            minDistance,
            minAngle,
            config.threejs.orbitControls.polarCameraCorrection,
            1000,
            TWEEN.Easing.Sinusoidal.InOut,
            () => {
                // setSmoothDistance();
            },
            () => {
        });
    }

    updateVariables(){
        this.minDistance = getOrbitControlsDistanceAndPan(ViewMode.FloorPlan).minDistance;
        this.maxDistance = getOrbitControlsDistanceAndPan(ViewMode.FloorPlan).maxDistance;
    }

    async exitFromMode(){
        if (userPrevent()) return;
        userPrevent(true);
        settingsData.activeModeSwitching = true;

        settingsData.buildingDestroyed = false;
        settingsData.aptFloorNum = false;
        disableArrowButtons();

        Amenities.show();

        if (Buildings.getBuildingsInfoLength() > 1) {
            this.buildingSwitcher.classList.remove('hide');
            enableSwitcherBtns(true);
        }

        flatLabelsRemove();
        // removeFloorSlider();
        this.floorSlider.remove();

        this.appearCameraAnimation();

        canvasResize();
        await floorMoveAnimation(settingsData.currentFloor, 'appear');

        setOrbitControls(ViewMode.Cylinder);
        setPolarAngle(ViewMode.Cylinder);
        setPanLimits(ViewMode.Cylinder);
        setMinAndMaxControlsDistance(ViewMode.Cylinder);
        setColorsKeyPlan();

        // settingsData.objectToDisappear.forEach(obj => {
        //     obj.forEach(objDis => {
        //         if (this.activeBuilding.name === objDis.parent.name) {
        //             objDis.visible = true;
        //         }
        //     });
        // });
        const activeBuilding = Buildings.getActiveBuilding();
        // const active = threeJsVariables.scene.getObjectByName(activeBuilding.name);
        // const roof = active.children.find(el => el.name.startsWith('Roof'));
        if (!projectMode.LiteMode.isActive() || projectMode.LiteMode.isActive() && projectMode.LiteMode.modeIs('regular')) {
            const roof = activeBuilding.amenities['Roof'].mesh;
            roof.position.y = roof.position.y - 400;
        }

        await cylinderFloorNumbers();
        rotateCylinderFloorNumbers();

        settingsData.activeViewMode = 'cylinder';
        settingsData.activeModeSwitching = false;
        userPrevent(false);
    }

}